<template>
  <div class="AreaNjNums">
    <div class="content_top">
      <!-- <a-form class="ant-advanced-search-form" :form="form" :layout="formLayout">
        <a-row>
          <a-col :xs="4" :sm="3">
            <a-form-item :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }">
              <a-select
                placeholder="选择区"
                style="width: 180px"
                @change="changeCountyAndGetTownsList"
                :allowClear="true"
                mode="multiple"
                :getPopupContainer="getPopupContainer"
              >
                <a-select-option v-for="item in countyList" :key="item.value" :label="item.label" :value="item.value"
                  >{{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="4" :sm="3">
            <a-form-item :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }">
              <a-select
                placeholder="作业类型"
                style="width: 180px"
                @change="changeWorkType"
                :allowClear="true"
                mode="multiple"
                :getPopupContainer="getPopupContainer"
              >
                <a-select-option v-for="item in buyNjList" :key="item.id" :label="item.catName" :value="item.id"
                  >{{ item.catName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="4" :sm="3">
            <a-form-item :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }">
              <a-range-picker
                format="YYYY-MM-DD"
                :placeholder="['作业开始日期', '作业结束日期']"
                @change="onChange"
                :defaultValue="[moment(getFirstDayOfYear(new Date()), dateFormats), moment(getNowFormatDates(), dateFormats)]"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="4" :sm="3">
            <a-form-item>
              <a-button type="primary" @click="handleSearch">查询</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form> -->
    </div>
    <!-- <div class="content_bottom">
      <div class="content_left">
        <div class="contents">
          <div class="content_left_left">
            <div>
              <p class="catName">作业合计（亩次）</p>
              <p class="nums">{{ areaSum }}</p>
            </div>
          </div>
          <div class="content_left_right">
            <div>
              <p class="catName">机具合计（台）</p>
              <p class="nums">{{ njSum }}</p>
            </div>
          </div>
        </div>
        <div class="contents_bot">
          <div v-for="(item, index) in selectAreaNjNumsList" :key="index" class="rows">
            <div class="content_left_left">
              <div>
                <p class="catName">{{ item.catName }}</p>
                <p class="nums">{{ item.area }}</p>
              </div>
            </div>
            <div class="content_left_right" v-for="(items, indexs) in item.monitorMachineEntityList" :key="indexs">
              <div>
                <p class="catName">{{ items.catName }}</p>
                <p class="nums">{{ item.countNumber }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_right">
        <div class="tablist_item">
          <div
            class="items"
            :class="[{ active: activeNames == item.name }]"
            v-for="item in itemList"
            :key="item.id"
            @click="tabItemClick(item)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="area">
          <div id="timeChart"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import moment from 'moment' // 时间插件
// import { mapState } from 'vuex'
// import Vue from 'vue'
// import echarts from 'echarts'
export default {
  name: 'AreaNjNums',
  data() {
    return {
      form: this.$form.createForm(this),
      formLayout: 'inline',
      search: {
        countyCode: '',
        workTypeId: '',
        applyTimeBegin: '',
        applyTimeEnd: ''
      },
      countyList: [],
      buyNjList: [],
      itemList: [
        {
          id: 1,
          name: '按日显示'
        },
        {
          id: 2,
          name: '按周显示'
        },
        {
          id: 3,
          name: '按月显示'
        }
      ],
      activeNames: '按日显示',
      groupType: 1,
      njMyCharts: '',
      selectAreaNjNumsList: [],
      selectAreaNjNumsLists: [],
      areaSum: '',
      njSum: '',
      dateFormats: 'YYYY-MM-DD',
      dateString: [],
      njMaxNum: ''
    }
  },
  beforeDestroy() {},
  created () {
    // this.search.applyTimeBegin = this.getFirstDayOfYear(new Date()).split('-')[0] + this.getFirstDayOfYear(new Date()).split('-')[1] + this.getFirstDayOfYear(new Date()).split('-')[2]
    // this.search.applyTimeEnd = this.getNowFormatDates().split('-')[0] + this.getNowFormatDates().split('-')[1] + this.getNowFormatDates().split('-')[2]
  },
  mounted() {
    // this.findMachinesType()
    // this.getCountyList(this.$store.getters.userInfo.areaCode)
    // // 表格统计左侧
    // this.getSelectAreaNjNums()
    // // 表格统计右侧
    // setTimeout(() => {
    //   this.$nextTick(() => {
    //     this.getSelectAreaNjRightNums()
    //     window.addEventListener('resize', () => {
    //       this.njMyCharts.resize()
    //     })
    //   })
    // })
  },
  methods: {
    // moment,
    getPopupContainer (trigger) {
      return trigger.parentElement
    },
    // 作业类型
    findMachinesType () {
      var url=Http.test+'/homePageStatis/findMachinesType'
      Api.doPost(url,{
        provCode: this.$store.getters.userInfo.provCode,
        countyCode: this.$store.getters.userInfo.countyCode,
        type: 2
      }, false, (res) => {
        this.buyNjList = res.result
      })
    },
    getSelectAreaNjNums() {
      var parmse = {
        provCode: this.$store.getters.userInfo.areaCode,
        beginDate: this.search.applyTimeBegin,
        endDate: this.search.applyTimeEnd,
        countyCodes: this.search.countyCode,
        machineIds: this.search.workTypeId
      }
      var url=Http.test+'/screenBuyNj/selectAreaNjNums'
      Api.doPost(url, parmse, false, res => {
        this.selectAreaNjNumsList = res.result.list
        this.areaSum = res.result.totalArea
        this.njSum = res.result.totalNum
      })
    },
    getSelectAreaNjRightNums() {
      var parmse = {
        provCode: this.$store.getters.userInfo.areaCode,
        beginDate: this.search.applyTimeBegin,
        endDate: this.search.applyTimeEnd,
        groupType: this.groupType,
        countyCodes: this.search.countyCode,
        machineIds: this.search.workTypeId
      }
      var url=Http.test+'/screenBuyNj/statisticWorkAreaNjnum'
      Api.doPost(url, parmse, false, res => {
        this.tabDataList = res.result
        this.chart(res.result)
      })
    },
    getCountyList(value) {
      var url=Http.test+'/screenBuyNj/statisticWorkAreaNjnum'
      Api.doPost(url, { provCode: value }, false, res => {
        this.countyList = res.result
      })
    },
    changeCountyAndGetTownsList(value) {
      this.search.countyCode = value.join(',')
    },
    changeWorkType(value) {
      this.search.workTypeId = value.join(',')
    },
    onChange(date, dateString) {
      this.dateString = dateString
      if (dateString[0] == '' || dateString[1] == '') {
        this.search.applyTimeBegin = ''
        this.search.applyTimeEnd = ''
      } else {
        this.search.applyTimeBegin =
          dateString[0].split('-')[0] + dateString[0].split('-')[1] + dateString[0].split('-')[2]
        this.search.applyTimeEnd =
          dateString[1].split('-')[0] + dateString[1].split('-')[1] + dateString[1].split('-')[2]
      }
    },
    handleSearch() {
      this.getSelectAreaNjNums()
      this.getSelectAreaNjRightNums()
    },
    timeFormat (date) {
      if (!date || typeof(date) === 'string') {
       this.error('参数异常，请检查...')
      }
      var y = date.getFullYear()  // 年
      // this.yearValue = y
      var m = date.getMonth() + 1 // 月
      var d = date.getDate() // 日
      if (m >= 1 && m <= 9) {
        m = '0' + m
      }
      if (d >= 1 && d <= 9) {
        d = '0' + d
      }
      return y + '-' + m + '-' + d
    },
    // 获取本年第一个月
    getFirstDayOfYear (date) {
      date.setDate(1)
      date.setMonth(0)
      return this.timeFormat(date)
    },
    // 获取当前月
    getNowFormatDates () {
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    exportExcel() {
      console.log('导出')
    },
    tabItemClick(item) {
      this.activeNames = item.name
      this.groupType = item.id
      this.getSelectAreaNjRightNums()
    },
    compare(property) {
      return function(a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    chart(data) {
      var resultarrs = data.map(item => {
        return item.dateStr
      })
      let resultarr = [...new Set(resultarrs)]
      var areaListData = []
      data.forEach(item => {
        if (item.type === 2) {
          areaListData.push(item)
        }
      })
      var njListData = []
      data.forEach(item => {
        if (item.type === 1) {
          njListData.push(item)
        }
      })
      var maxArr = []
      njListData.forEach(item => {
        maxArr.push(item.countNumber)
        
      })
      this.njMaxNum = Math.max(...maxArr)
      // 耕地作业
      var arrs = []
      data.forEach(item => {
        if (item.catName === '耕地作业') {
         arrs.push(item.area)
        }
      })
      var arr1 = []
      data.map(item => {
        if (item.catName === '收获作业') {
          arr1.push(item.area)
        }
      })
      // 水稻插秧
      var arr2 = []
      data.map(item => {
        if (item.catName === '水稻插秧') {
          arr2.push(item.area)
        }
      })
      // 水稻直播
      var arr3 = []
      data.map(item => {
        if (item.catName === '水稻直播') {
          arr3.push(item.area)
        }
      })
      // 植保作业
      var arr4 = []
      data.map(item => {
        if (item.catName === '植保作业') {
          arr4.push(item.area)
        }
      })
      var arr5 = []
      data.map(item => {
        if (item.catName === '拖拉机') {
          arr5.push(item.countNumber)
        }
      })
      var arr6 = []
      data.map(item => {
        if (item.catName === '收获机') {
          arr6.push(item.countNumber)
        }
      })
      var arr7 = []
      data.map(item => {
        if (item.catName === '直播机') {
          arr7.push(item.countNumber)
        }
      })
      var arr8 = []
      data.map(item => {
        if (item.catName === '植保机') {
          arr8.push(item.countNumber)
        }
      })
      var arr9 = []
      data.map(item => {
        if (item.catName === '插秧机') {
          arr9.push(item.countNumber)
        }
      })
      this.njMyCharts = echarts.init(document.getElementById('timeChart'))
      this.njMyCharts.setOption({
        title: {
          // text: '作业面积（亩）',
          // left: 19,
          // top: 15,
          textStyle: {
            color: '#555555',
            // fontStyle: 'normal',
            fontSize: 14
          }
        },
        color: ['#429df9', '#76c144', '#ed8437', '#41d4eb', '#a86de4'],
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
          // formatter: function(params){
          //   for (var i in params) {
          //     return "<div><p>耕地作业: " + params[i].value +"亩</p></div>"
          //   }
          // },
        },
        dataZoom: [ 
          //X轴滑动条
          {
            type: 'slider', //滑动条
            // show: this.groupType === 1 ? true : false, //开启
            show: true, //开启
            xAxisIndex: [0],
            left: '6%',  //滑动条位置
            bottom: '16%',
            start: 1,    //初始化时，滑动条宽度开始标度
            end: 30      //初始化时，滑动条宽度结束标度
          },
          //X轴内置滑动
          {
            type: 'inside',  //内置滑动，随鼠标滚轮展示
            xAxisIndex: [0],
            start: 1,//初始化时，滑动条宽度开始标度
            end: this.groupType === 1 ? 30 : 100  //初始化时，滑动条宽度结束标度
          }
        ],
        legend: {
          // orient: 'vertical',
          show: true,
          bottom: 0,
          left: '22%',
          itemWidth: 14,
          itemHeight: 14,
          itemGap: 20,
          textStyle: {
            fontSize: 14,
            // color: '#96A4F4',
            // fontWeight: 'bold',
            padding: [3, 0, 0, 0]
          },
          padding: 20,
          data: [
            '拖拉机',
            '插秧机',
            '直播机',
            '植保机',
            '收获机',
            '',
            '耕地作业',
            '水稻插秧',
            '水稻直播',
            '植保作业',
            '收获作业'
          ]
        },
        grid: {
          top: '5%',
          left: '2%',
          right: '2%',
          bottom: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#a0a0a0',
            // fontSize: 14,
            rotate: 45
            // fontWeight: 'bold'
          },
          axisLine: {
            lineStyle: {
              color: '#dddddd'
            },
            width: 5
          },
          axisTick: {
            show: false
          },
          data: resultarr
        },
        yAxis: [
          {
            type: 'value',
            name: '作业面积（亩）',
            position: 'right',
            nameTextStyle: {
              color: '#a0a0a0'
            },
            axisLabel: {
              show: true,
              color: '#a0a0a0'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#dddddd'
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(150, 164, 244, 0.3)'
              }
            }
          },
          {
            type: 'value',
            name: '机具数量（台）',
            // max: this.njMaxNum + 100,
            nameTextStyle: {
              color: '#a0a0a0'
            },
            axisLabel: {
              show: true,
              color: '#a0a0a0'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#dddddd'
              },
              width: 5
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {           
                width: 0.2,
                type: 'dashed',
                color: '#e9e9e9'
              }
            }
          },
        ],
        series: [
          {
            name: '耕地作业',
            type: 'line',
            z: 2,
            // type: 'bar',
            // stack: '总量',
            // barWidth: 15,
            // yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arrs
          },
          {
            name: '水稻插秧',
            type: 'line',
            z: 2,
            // type: 'bar',
            // stack: '总量',
            // barWidth: 15,
            // yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr2
          },
          {
            name: '水稻直播',
            type: 'line',
            z: 2,
            // type: 'bar',
            // stack: '总量',
            // barWidth: 15,
            // yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr3
          },
          {
            name: '植保作业',
            type: 'line',
            z: 2,
            // type: 'bar',
            // stack: '总量',
            // barWidth: 15,
            // yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr4
          },
          {
            name: '收获作业',
            type: 'line',
            z: 2,
            // type: 'bar',
            // stack: '总量',
            // barWidth: 15,
            // yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr1
          },
          {
            name: '拖拉机',
            // type: 'line',
            type: 'bar',
            stack: '总量',
            barWidth: 15,
            yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr5
          },
          {
            name: '插秧机',
            type: 'bar',
            stack: '总量',
            barWidth: 15,
            yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr9
          },
          {
            name: '直播机',
            type: 'bar',
            stack: '总量',
            barWidth: 15,
            yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr7
          },
          {
            name: '植保机',
            type: 'bar',
            stack: '总量',
            barWidth: 15,
            yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr8
          },
          {
            name: '收获机',
            type: 'bar',
            stack: '总量',
            barWidth: 15,
            yAxisIndex: 1,
            label: {
              show: false,
              position: 'insideTop'
            },
            data: arr6
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
.AreaNjNums {
  width: 100%;
  height: 100%;
}
.content_bottom {
  display: flex;
}
.content_left {
  width: 45%;
  height: 700px;
}
.contents {
  width: 80%;
  border: solid 1px #eeeeee;
  display: flex;
  margin-top: 60px;
}
.contents {
  border-bottom: none;
  background: #f9f9f9;
}
.contents_bot{
  width: 80%;
  border: solid 1px #eeeeee;
}
.contents_bot{
  border-top: none;
}
.rows{
  width: 100%;
  display: flex;
}
.content_left_left {
  width: 50%;
  text-align: center;
  border-right: solid 1px #eeeeee;
}
.content_left_left div {
  border-bottom: solid 1px #eeeeee;
  height: 80px;
  padding-top: 10px;
}
.content_left_right div:nth-child(6) {
  border-bottom: none;
}
.content_left_right {
  width: 50%;
  text-align: center;
}
.catName{
  color: #a0a0a0;
}
.nums {
  font-size: 24px;
}
.content_left_right div {
  border-bottom: solid 1px #eeeeee;
  height: 80px;
  padding-top: 10px;
}
.content_left_right div:nth-child(6) {
  border-bottom: none;
}
.content_right {
  width: 55%;
  height: 700px;
}
.tablist_item {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  margin-left: 33%;
}
.items {
  width: 80px;
  height: 30px;
  background-color: #f4f4f4;
  color: #000;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  margin-right: 10px;
  border-radius: 15px;
  cursor: pointer;
}
.items.active {
  width: 80px;
  height: 30px;
  background-color: #0048c2;
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  border-radius: 15px;
}
.area {
  width: 100%;
  height: 600px;
}
#timeChart {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/AreaNjNums.vue